'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('../../components');

var _constants = require('../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Header component.
 * @param {HeaderPropsType} props element
 * @returns {ReactElement} React element
 */
var HeaderComponent = function HeaderComponent(_ref) {
  var _ref$t = _ref.t,
      t = _ref$t === undefined ? function () {
    var ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return function (msg) {
      return '' + ctx + msg;
    };
  } : _ref$t,
      onClick = _ref.onClick,
      showCloseButton = _ref.showCloseButton;

  var componentTitle = t(_constants.TRANSLATION_CONTEXT)('APP_TITLE');
  var closeButtonLabel = t(_constants.TRANSLATION_CONTEXT)('APP_CLOSE_BUTTON_LABEL');

  /**
   * Render method for the component
   * @returns {Element<*>} the react element
   */
  return _react2.default.createElement(
    'div',
    { className: 'qd__header' },
    _react2.default.createElement(
      'div',
      { className: 'qd__header_title' },
      _react2.default.createElement(
        'span',
        null,
        componentTitle
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'qd__header_close' },
      !!showCloseButton && _react2.default.createElement(_components.CloseButton, { title: closeButtonLabel, onClick: onClick })
    )
  );
};

exports.default = HeaderComponent;